import createTable from './CompanyDetailsTable';

export default createTable({
  namePrefix: 'customFields',
  tableName: 'Custom Fields',
  columns: [{ field: 'fieldName' }, { field: 'fieldValue', title: 'Field Data' }],
});
